import { render, staticRenderFns } from "./IvtEditUI.vue?vue&type=template&id=957e8204&"
import script from "./IvtEditUI.vue?vue&type=script&lang=ts&"
export * from "./IvtEditUI.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports